import React from 'react'
import { Link } from 'gatsby'

interface ButtonProps {
  href?: string
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'accent' | 'outline'
  size?: 'small' | 'medium' | 'large'
  children: React.ReactNode
  className?: string
  external?: boolean
}

const Button: React.FC<ButtonProps> = ({
  href,
  onClick,
  variant = 'primary',
  size = 'medium',
  children,
  className = '',
  external = false
}) => {
  const variantStyles = {
    primary: 'btn btn-primary',
    secondary: 'btn-secondary btn',
    accent: 'bg-accent text-white border-accent',
    outline: 'bg-transparent text-primary border-primary'
  }

  const sizeStyles = {
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2',
    large: 'px-6 py-3 text-lg'
  }

  const baseStyles = `inline-block mt-0 font-semibold rounded-lg border-2 transition-colors duration-200 hover:opacity-80 ${variantStyles[variant]} ${sizeStyles[size]} ${className}`

  if (href) {
    if (external || href.startsWith('http')) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={baseStyles}
        >
          {children}
        </a>
      )
    }
    return (
      <Link to={href} className={baseStyles}>
        {children}
      </Link>
    )
  }

  return (
    <button onClick={onClick} className={baseStyles}>
      {children}
    </button>
  )
}

export default Button